import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import {
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { AssetsService } from '@sc/data-access-assets';
import { IconComponent } from '@sc/ui-components';
import { Observable } from 'rxjs';
import { ProductTourService } from '../../services/product-tour-service';

@Component({
  selector: 'sc-help-fab-button',
  styleUrls: ['./help-fab-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgIf,
    MatMenuModule,
    NgClass,
    IconComponent,
    AsyncPipe,
    TranslateModule,
  ],
  template: `
    <button
      mat-button
      *ngIf="displayHelp$ | async"
      [matMenuTriggerFor]="menu"
      class="button fab"
      (click)="menuOpen()"
      [ngClass]="{ 'button-fab-opened': menuOpened }"
    >
      <sc-icon aria-hidden="true" class="icon" name="help"></sc-icon>
      {{ 'GlobalApplicativeConstants.productTour.tips.help' | translate }}
    </button>
    <mat-menu #menu="matMenu" (closed)="menuOpened = false" yPosition="above">
      <button mat-menu-item class="menu-button" (click)="showTips()">
        <sc-icon name="arrow_right" aria-hidden="true"></sc-icon>
        {{ 'GlobalApplicativeConstants.productTour.tips.showMore' | translate }}
      </button>
    </mat-menu>
  `,
})
export class HelpFabButtonComponent {
  menuOpened = false;
  displayHelp$: Observable<boolean> = this.productTourService.displayHelp$;

  constructor(
    public assetsService: AssetsService,
    public productTourService: ProductTourService
  ) {}

  @Output() showTipsEvent: EventEmitter<void> = new EventEmitter<void>();

  menuOpen() {
    this.menuOpened = true;
  }

  showTips() {
    this.showTipsEvent.emit();
  }
}
